import { FC, forwardRef } from 'react';
import { LabeledCheckbox } from '@fe-learner-common';

type CheckboxProps = {
  filterKey: string;
  label: string;
  items: { key: string; label: string; selected: boolean }[];
  onChange: (value: string) => void;
};

export const MultipleChoice: FC<CheckboxProps> = forwardRef<
  HTMLDivElement,
  CheckboxProps
>(({ filterKey, onChange, label, items }, ref) => {
  const ariaKey = `filter-group-${filterKey}`;
  return (
    <div ref={ref} role="group">
      <div className="lf:flex lf:items-center lf:justify-between lf:px-3 lf:py-3.5">
        <h2 className="lf:text-label-md  lf:leading-5 lf:text-neutral-500" id={ariaKey}>
          {label}
        </h2>
      </div>
      <div className="lf:gap-y-2">
        {items.map((item) => (
          <LabeledCheckbox
            size="md"
            checked={item.selected}
            onChange={() => onChange(item.key)}
            key={`checkbox-option-${filterKey}-${item.key}`}
            id={`checkbox-option-id-${filterKey}-${item.key}`}
            label={item.label}
          />
        ))}
      </div>
    </div>
  );
});

MultipleChoice.displayName = 'MultipleChoice';
